import { STATIC_PICS_URL, STATIC_TERMS_URL } from '@/utils/policyDocuments';

export type FooterDocumentKind = 'policy' | 'terms';

export type FooterLinkItem = {
  name: string;
  url: string;
  documentKind?: FooterDocumentKind;
};

export type FooterLinkGroup = {
  key?: string;
  title: string;
  link: FooterLinkItem[];
};

const documentKindFromUrl = (url: string): FooterDocumentKind | null => {
  if (url === STATIC_PICS_URL) return 'policy';
  if (url === STATIC_TERMS_URL) return 'terms';
  return null;
};

export const applyPolicyDocumentsToFooterLinks = (
  groups: FooterLinkGroup[],
  documents: { policyUrl: string; termsUrl: string }
): FooterLinkGroup[] =>
  groups.map((group) => {
    if (group.key !== 'Resources') return group;

    return {
      ...group,
      link: group.link.map((item) => {
        const documentKind = item.documentKind || documentKindFromUrl(item.url);
        if (!documentKind) return item;

        return {
          ...item,
          documentKind,
          url: documentKind === 'policy' ? documents.policyUrl : documents.termsUrl,
        };
      }),
    };
  });

export const isExternalFooterUrl = (url: string) =>
  /^https?:\/\//i.test(url) || /^\/(?:api|files)\//i.test(url);
